
const LangReducer = (state, action) => {
    switch (action.type) {
      case "CHANGE_LANG":
        return {
          lang: action.payload,
        };
      default:
        return {...state};
    }
  };
  
  export default LangReducer;